// extracted by mini-css-extract-plugin
export default {"btn":"NoItemsNotificationWithLink_btn__0e8sA"};